import { put, select, takeEvery, takeLatest } from "redux-saga/effects";

import { requestMiddleware } from "helpers/api";
import { getWikiDetails } from "services/api/map";
import { getProject } from "services/api/project";
import { putPointTrainingClassification } from "services/api/units";
import { actions } from "./ducks";
import features from "features";
import { MapModes, MapToolsModes } from "constant";
import { LocalStorageProvider } from "services/LocalStorageProvider";

function* fetchProject({ payload }) {
  const request = getProject;

  const { fetchProjectSuccess: setSuccess, fetchProjectError: setError } =
    actions;

  function* onSuccess(res) {
    if (res.layers?.length)
      yield put(
        features.layersManager.actions.setLayers({
          params: payload.params,
          layers: res.layers
        })
      );
  }

  yield requestMiddleware({
    ...payload,
    request,
    setSuccess,
    setError,
    onSuccess
  });
}

function* fetchPointWikiDetails({ payload }) {
  const request = getWikiDetails;

  const {
    fetchPointWikiDetailsSuccess: setSuccess,
    fetchPointWikiDetailsError: setError
  } = actions;

  yield requestMiddleware({
    ...payload,
    request,
    setSuccess,
    setError
  });
}

function* initPointData({ payload }) {
  const { jwtData } = yield select((state) => state.auth);
  const { fetchPointWikiDetailsRequest } = actions;
  const id = payload.additional.mine_id;

  const isWikiPolicy = jwtData?.policies.includes("wiki_general");

  if (id && isWikiPolicy)
    yield put(fetchPointWikiDetailsRequest({ params: { id } }));
}

function* initMapTools({ payload }) {
  const { setMapMode } = actions;
  if (payload === MapToolsModes.LAYERS) {
    yield put(features.missionsManager.actions.clearMission());
  }
  yield put(features.unitsManager.actions.clearCreationPolygonParameters());
  yield put(features.unitsManager.actions.clearCreationPolygonHistory());

  yield put(setMapMode(MapModes.DEFAULT));
}

function* watchAriaIsActive({ payload }) {
  LocalStorageProvider.projects.setHazardZonesState({
    projectId: payload.projectId,
    updatedState: {
      [payload.alias]: payload.isActive
    }
  });
}

function* fetchClassifyPoint({ payload }) {
  const request = putPointTrainingClassification;

  const {
    updatePointTrainingClassificationSuccess: setSuccess,
    updatePointTrainingClassificationError: setError
  } = actions;

  yield requestMiddleware({
    ...payload,
    request,
    setSuccess,
    setError,
    isReturnRequestPayload: true
  });
}

export default function* watchSaga() {
  yield takeLatest(actions.fetchProjectRequest, fetchProject);
  yield takeLatest(actions.fetchPointWikiDetailsRequest, fetchPointWikiDetails);
  yield takeLatest(actions.setPointDetails, initPointData);
  yield takeEvery(
    actions.updatePointTrainingClassificationRequest,
    fetchClassifyPoint
  );
  yield takeLatest(actions.setMapToolsMode, initMapTools);
  yield takeLatest(actions.setAriaIsActive, watchAriaIsActive);
}
